import { layer as consoleLayer } from '@rango-dev/logging-console';
import { layer as sentryLayer } from '@rango-dev/logging-sentry';
import { init, Level } from '@rango-dev/logging-subscriber';
import * as Sentry from '@sentry/browser';
import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import './index.css';

import Bootstrap from './Bootstrap';
import { CustomSocialWalletProvider } from './components/CustomSocialWalletProvider';
import { IS_DEV } from './constants/api';
import { SENTRY_DSN } from './constants/sentry';
import { persistor, store } from './state/Store';
import './data/i18n';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// Note: Some of properties like release and app version is setting from `vite.config`
Sentry.init({ dsn: SENTRY_DSN, normalizeDepth: 6 });

if (IS_DEV) {
  init([consoleLayer()], {
    baseLevel: Level.Debug,
  });
} else {
  init([sentryLayer(Sentry)], {
    baseLevel: Level.Warn,
  });
  init([consoleLayer()], {
    baseLevel: Level.Debug,
  });
}

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <CustomSocialWalletProvider>
          <Bootstrap />
        </CustomSocialWalletProvider>
      </PersistGate>
    </Provider>
  </StrictMode>,
);
